export type GetComponentsResponse = {
  /**
   * The results of this get_components response body.
   */
  rootCpntDelFlg: string;
  rootCpntId: string;
  rootCpntName: string;
  dipByRgn: string;
  ownTypeCd: string;
  ownTypeName: string;
  systemName: string;
  systemId: string;
  subSystemId: string;
  notSysUsg: string;
  alctnTypeCd: string;
  alctnTypeName: string;
  clodSrvcTypeCd: string;
  clodSrvcTypeName: string;
  rgnTypeCd: string;
  rgnTypeName: string;
  acntName: string;
  updateDateTimeMRootCpnt: string;
  rootCpntIchrList: RootCpntIchr[];
  cpntList: Component[];
};

export type RootCpntIchr = {
  ichrId: string;
  ichrName: string;
  pstnName: string;
  cmpnyName: string;
  telNum: string;
  mlAdrs: string;
  updateDateTimeMRootCpntIchr: string;
};

export type Component = {
  cpntDelFlg: string;
  dipByRgn: string;
  cpntId: string;
  cpntName: string;
  cpntDesc: string;
  gpgEncryptnFlg: string;
  useAssmdRoleFlg: string;
  useEdhCnvtrFlg: string;
  ediUsgFlg: string;
  hubFlg: string;
  updateDateTimeMCpnt: string;
  edhPrtclList: EdhPrtcl[];
  cmpProject: string;
};

export type EdhPrtcl = {
  edhPrtclDsplyNameConcat: string;
};
